import styles from './mapStyles';

export default function initMap() {
	var lat = window.home_map.lat || -33.877500;
	var long = window.home_map.long || 151.09450;

    var mapElement = document.getElementById('map');

    if(! mapElement) {
        return;
    }

    // get the coordinates from the street address https://www.latlong.net/
    var address = {lat: parseFloat(lat), lng: parseFloat(long) };

    var map = new google.maps.Map(mapElement, {
        zoom: 15,
        center: address,
        // Use https://mapstyle.withgoogle.com/ OR https://snazzymaps.com/ to generate the map style
        // The default styles applied below are the 'Silver' theme from google
        styles: styles,
    });
    var icon = {
        path: "M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,0 15,0 C23.2842969,0 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z",
        fillColor: '#ee2d3a',
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 1,
        anchor: new google.maps.Point(30, 40),
        size: new google.maps.Size(60,40),
    };
    var marker = new google.maps.Marker({
        position: address,
        map: map,
        icon: icon
    });

    google.maps.event.addDomListener(window, 'load', initMap);
}